module.exports = __webpack_public_path__ + "img/logo-digi.b37f20ff.png";